import React from 'react';
import { ENTITY_TYPE } from 'draft-js-utils';

export const ICON_DATA_KEY = 'data-icon';

// アイコン同士の隙間。表示側は app-rte.scss の `a + a > img[data-icon]` に同じ値がある。
export const ICON_GAP_PX = 8;

export const iconSizes = {
  sm: { label: '小', px: 24 },
  md: { label: '中', px: 40 },
  lg: { label: '大', px: 64 },
};

export const iconSizePx = (size) => (iconSizes[size] || iconSizes.md).px;

const getIconEntityData = (contentState, entityKey) => {
  if(entityKey == null) return null;

  const entity = contentState.getEntity(entityKey);
  if(entity.getType() !== ENTITY_TYPE.IMAGE) return null;

  const data = entity.getData();
  return data[ICON_DATA_KEY] != null ? data : null;
};

const findIconEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(
    _ => getIconEntityData(contentState, _.getEntity()) != null,
    callback,
  );
};

// エディタ内でのアイコン表示。
// className を "ImageSpan" で始めないことで、app-rte.scss の
// span[class^="ImageSpan"] { width: 100% !important } の対象から外す。
const IconSpan = (props) => {
  const { contentState, entityKey, children } = props;
  const data = getIconEntityData(contentState, entityKey);
  const px = iconSizePx(data[ICON_DATA_KEY]);

  return (
    <span
      className="rte-icon-span"
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        // エディタ内は draft-js が各 decorator を span で包むため隣接セレクタが使えない。
        // 編集中の目安なので、右マージンで簡易に隙間を作る。
        marginRight: ICON_GAP_PX,
        backgroundImage: `url("${data.src}")`,
        backgroundSize: `${px}px ${px}px`,
        backgroundRepeat: 'no-repeat',
        width: px,
        height: px,
        lineHeight: `${px}px`,
        fontSize: `${px}px`,
        letterSpacing: px,
      }}
    >
      {children}
    </span>
  );
};

const IconDecorator = {
  strategy: findIconEntities,
  component: IconSpan,
};

export default IconDecorator;
